import { useQuery } from '@tanstack/react-query';
import { AUTOMATION_PENDING_CONFIRMATION } from '../../utils/constants/queryKeys';
import { getAutomationPendingConfirmation } from '../services/fn-api/AutomationPendingConfirmation';

export const useGetAutomationPendingConfirmation = (beneId: number) => {
  return useQuery({
    queryKey: [AUTOMATION_PENDING_CONFIRMATION, beneId],
    queryFn: () => getAutomationPendingConfirmation(beneId),
    enabled: !!beneId,
  });
};
